import { useEffect, useRef, useState } from 'react'
import { HEADER_AUTO_HIDE } from '../constants/scroll'

export function useHeaderAutoHide(pinned: boolean) {
  const [hidden, setHidden] = useState(false)
  const lastY = useRef(0)
  const headerRef = useRef<HTMLElement>(null)
  const keepVisibleRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const header = headerRef.current
    if (!header) return

    function measure() {
      const keep = keepVisibleRef.current
      const offset = keep?.offsetParent ? keep.offsetTop : header!.offsetHeight
      header!.style.setProperty(HEADER_AUTO_HIDE.offsetVar, `${offset}px`)
    }

    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(header)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    let frame = 0
    lastY.current = window.scrollY

    function update() {
      frame = 0
      const y = window.scrollY
      const delta = y - lastY.current

      if (y <= HEADER_AUTO_HIDE.revealAbovePx) {
        setHidden(false)
      } else if (Math.abs(delta) >= HEADER_AUTO_HIDE.minDeltaPx) {
        setHidden(delta > 0)
      } else {
        return
      }
      lastY.current = y
    }

    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(update)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [])

  return { hidden: hidden && !pinned, headerRef, keepVisibleRef }
}
